import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { WindowContextProvider } from "./contexts/WindowContext";

import "./services/axiosInterceptors"

import store from "./store";


const app = (
  <Provider store={store}>
    <WindowContextProvider>
      <App />
    </WindowContextProvider>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
